import { useContext } from 'react';
import { MaterialManageContext } from '../hooks/MaterialManageContext';
import ContentHeader from '../components/ContentHeader';
import MaterialCard from '../components/MaterialCard';
import styles from './index.module.scss';

// 模拟数据
const mockList = Array.from({ length: 20 }, (_, i) => ({
    id: i + 1,
    name: '鲜花',
    url: '',
    folderName: '文件夹名...',
    time: '2025/12/26 10:05',
}));

const ContentArea = () => {
    const {
        activeMenuName,
        total,
        searchKeyword, setSearchKeyword,
        batchMode, setBatchMode,
        selectedList, setSelectedList,
        materialList,
    } = useContext(MaterialManageContext);

    const displayList = materialList.length > 0 ? materialList : mockList;

    return (
        <div className={styles.ContentArea}>
            <ContentHeader
                title={activeMenuName}
                total={total || displayList.length}
                searchKeyword={searchKeyword}
                onSearch={setSearchKeyword}
                batchMode={batchMode}
                onBatchMode={setBatchMode}
            />
            <div className={`${styles.materialGrid} _beauty_scrollbar`}>
                {displayList.map(item => (
                    <MaterialCard
                        key={item.id}
                        item={item}
                        selected={selectedList.includes(item.id)}
                        batchMode={batchMode}
                        onSelect={(id) => {
                            if (selectedList.includes(id)) {
                                setSelectedList(prev => prev.filter(v => v !== id));
                            } else {
                                setSelectedList(prev => [...prev, id]);
                            }
                        }}
                    />
                ))}
            </div>
        </div>
    );
};

export default ContentArea;